import * as React from 'react'
import {StoreCardErrorBoundary} from './store-card-error-boundary'
import { StoreIntCardLoadingIndicator } from './store-card-loading-indicator'
import { LazyLoadComponentWrapper } from '@components/lazy-load/lazy-load-component-wrapper'
const StoreDashboardCard = React.lazy(() => import(/* webpackChunkName: "mdum-card" */ './index'))
const StoreIntServiceContainer = () => (
  <LazyLoadComponentWrapper
     fallback={<StoreIntCardLoadingIndicator/>}
     errorIndicator={<StoreCardErrorBoundary/>}>
      <StoreDashboardCard uiid="ui-storeInt-container-card" />
  </LazyLoadComponentWrapper>
)

export default StoreIntServiceContainer
